import { LoginForm } from "./components";

export function LoginPage() {
  return (
    <div className="h-screen w-full flex bg-slate-50 font-sans selection:bg-emerald-500/30 overflow-hidden relative">
      {/* 🖼️ Clean Visual Side */}
      <div className="hidden lg:flex w-[40%] relative overflow-hidden">
        <img
          src="/stadium-bg.png"
          alt="Stadium"
          className="absolute inset-0 w-full h-full object-cover brightness-[0.7] contrast-[1.1]"
        />
        <div className="absolute inset-0 bg-linear-to-t from-emerald-950/80 via-transparent to-transparent" />

        <div className="relative z-10 p-16 flex flex-col justify-end h-full">
          <div className="mb-8">
            <div className="w-14 h-14 bg-white/10 backdrop-blur-xl rounded-2xl flex items-center justify-center border border-white/20 shadow-2xl mb-8">
              <span className="text-white font-black text-2xl uppercase tracking-tighter">
                PM
              </span>
            </div>
            <h1 className="text-4xl font-bold text-white tracking-tight leading-tight">
              Bienvenido a <br />
              <span className="text-emerald-400">Polla Master.</span>
            </h1>
            <p className="text-white/80 text-lg mt-4 max-w-sm">
              La plataforma más intuitiva para tus predicciones deportivas.
            </p>
          </div>
        </div>
      </div>

      {/* 🔐 Simple Authentication Side */}
      <div className="w-full lg:w-[60%] flex items-center justify-center p-8 bg-white relative">
        <div className="w-full max-w-md">
          <div className="mb-10">
            <div className="lg:hidden mb-8">
              <span className="text-emerald-600 font-black text-2xl tracking-tighter italic">
                POLLA MASTER
              </span>
            </div>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight mb-2">
              Iniciar Sesión
            </h2>
            <p className="text-slate-500 font-medium">
              Gestiona tus jugadas y resultados en tiempo real.
            </p>
          </div>

          <div className="relative">
            <LoginForm />
          </div>

          {/* Practical Footer */}
          <div className="mt-16 pt-8 border-t border-slate-100 flex flex-col sm:flex-row justify-between items-center gap-4 text-slate-400 text-sm">
            <p>&copy; 2026 Polla Master</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-emerald-600 transition-colors">
                Soporte
              </a>
              <a href="#" className="hover:text-emerald-600 transition-colors">
                Privacidad
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
